import {validateNativeCallLaneBars} from './call-lane-bar';

const object=(value:unknown):value is Record<string,unknown>=>
  !!value&&typeof value==='object'&&!Array.isArray(value);
const positive=(value:unknown):value is number=>
  typeof value==='number'&&Number.isFinite(value)&&value>0;

/** Exact native phone inventory admitted at the initial raw handoff boundary. */
export function hasNativeCallLaneInventory(value:unknown):boolean {
  if(!object(value)||!object(value.items)||!object(value.assets)||!Array.isArray(value.tracks)
    ||!object(value.transferReport)||!Array.isArray(value.transferReport.sourceStatuses)
    ||!Array.isArray(value.transferReport.transferred)||!validateNativeCallLaneBars(value))return false;
  const items=value.items,assets=value.assets;
  if(Object.keys(items).length>10000||value.tracks.length>1000)return false;
  const background=items['waka-story-root-canvas-background'];
  if(!object(background)||background.type!=='solid')return false;
  const track=value.tracks.find(entry=>object(entry)&&entry.id==='waka-call-lane');
  if(!object(track)||!Array.isArray(track.items)||new Set(track.items).size!==track.items.length)return false;
  const trackItems=track.items as unknown[];
  const owns=(id:string)=>trackItems.includes(id);
  const statuses=value.transferReport.sourceStatuses.filter(object);
  for(const side of [0,1]){
    const id=`waka-call-seat-${side}`,seat=items[id];
    if(!object(seat)||seat.type!=='solid'||!owns(id)||!statuses.some(source=>
      source.provenance===`story.callLane.avatars[${side}]`&&source.status==='transferred'))return false;
    if(statuses.some(source=>source.provenance===`story.cast[${side}].refUrl`)){
      const portrait=items[`waka-call-portrait-${side}`];
      if(!object(portrait)||portrait.type!=='image'||!owns(`waka-call-portrait-${side}`)
        ||typeof portrait.assetId!=='string'||!object(assets[portrait.assetId])
        ||(assets[portrait.assetId] as Record<string,unknown>).type!=='image')return false;
    }
  }
  const first=items['waka-call-bar-0'];
  if(!object(first)||first.type!=='solid'||!object(first.wakaCallLaneBar))return false;
  const countRaw=first.wakaCallLaneBar.count;
  if(typeof countRaw!=='number'||!Number.isInteger(countRaw)||countRaw<1||countRaw>64)return false;
  const count=countRaw;
  if(Object.values(items).filter(item=>object(item)&&item.type==='solid'&&item.wakaCallLaneBar!==undefined).length!==count)return false;
  for(let index=0;index<count;index++){
    const id=`waka-call-bar-${index}`,bar=items[id];
    if(!object(bar)||bar.type!=='solid'||!object(bar.wakaCallLaneBar)
      ||bar.wakaCallLaneBar.index!==index||bar.wakaCallLaneBar.count!==count||!owns(id)
      ||bar.from!==0||bar.durationInFrames!==value.durationInFrames)return false;
  }
  const captionSources=value.transferReport.transferred.filter(entry=>
    object(entry)&&typeof entry.sourceId==='string'&&entry.sourceId.startsWith('call-caption-'));
  return captionSources.length>0&&captionSources.every(entry=>Array.isArray(entry.targetItemIds)
    &&entry.targetItemIds.length>0&&entry.targetItemIds.every((id:unknown)=>typeof id==='string'
      &&object(items[id])&&items[id].type==='captions'
      &&typeof items[id].assetId==='string'&&object(assets[items[id].assetId])
      &&(assets[items[id].assetId] as Record<string,unknown>).type==='caption'));
}

export function isPhoneRawHandoffState(value:unknown):boolean {
  return object(value)&&value.version==='1.1.0'&&value.saved===true
    &&positive(value.durationInFrames)&&Number.isSafeInteger(value.durationInFrames)
    &&positive(value.fps)&&positive(value.compositionWidth)&&positive(value.compositionHeight)
    &&hasNativeCallLaneInventory(value);
}

/** Schema 2 is deliberately unreadable and unwritable by the old schema-1 editor. */
export function isPhoneRawHandoffEnvelope(value:unknown):boolean {
  return object(value)&&value.schemaVersion===2&&value.format===undefined
    &&isPhoneRawHandoffState(value.state);
}
